module.exports = __webpack_public_path__ + "img/rulebook-icon.aea1ebb5.svg";